export const kycMethods = [
  { label: 'System KYC', value: 0 },
  { label: 'Sumsub', value: 1 }
]
